<template>
    <section>
        <!--        <SurveyNotice :dialog.sync="dialog"/>-->
        <v-form ref="vuePreviewSurveyDataframe_form" style="margin-top:20px;">
            <v-container v-if="questionaire === '' && isSurveyDeleted">{{surveyDeletedMessage}}</v-container>
            <v-container v-else-if="questionaire == null || questionaire === '' || showEmptyMessage ">{{$t('empty_dataframe_message')}}</v-container>
            <div v-else>
                <v-container>
                    <p class="text-start display-1"><strong> <span v-if="survey['questionaireName']">{{survey.questionaireName}}</span><span v-else>{{$t('Survey')}}</span></strong></p>
                </v-container>
                <div v-for="(question, index) in questionaire" :key="question.questionId"  >
                    <div :id="'question_'+index" v-show="dependentQuestion['show_'+question.questionId]" >
                        <question-template  :question="question" :index="index" />
                    </div>
                </div>
            </div>
        </v-form>
        <p class="text-start" style="color: red;margin-right: 20px;"> <span v-if="_questionaire.showImportantQuestionMessage">{{$t('importantQuestionMessage')}}</span></p>
        <v-card-actions v-if="!showEmptyMessage && !isSurveyDeleted">
            <v-btn class="ma-4" color="light-blue darken-2" dark @click="submit" :loading="loading" id="save-survey">{{$t('save')}}</v-btn>
            <v-btn class="ma-4" color="light-blue darken-2" dark @click="clear" id="clear-survey">{{$t('clear')}}</v-btn>
        </v-card-actions>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar
                v-model="successNotification.show"
                :color="successNotification.type"
                :timeout="successNotification.timeout"
                top="top"
        >
            {{successNotification.message}}
        </v-snackbar>
        <v-snackbar
                v-model="notification.show"
                :color="notification.type"
                :timeout="notification.timeout"
                top="top"
        >
            {{notification.message}}
        </v-snackbar>
        <PrivacyPolicy  :dialog="dialog" @closePrivacyDialog="closePrivacyDialog"/>
    </section>
</template>

<script>
import axios from 'axios'
import config from "../ayalconfig";
import offlineStorage from "../dbService";
import Vuex, {mapGetters, mapMutations} from "vuex";
import QuestionTemplate from "./QuestionTemplate"
import SystemUtils from "../service/systemUtil";
import PrivacyPolicy from "./PrivacyPolicy";
// import SurveyNotice from "./SurveyNotice";
export default {
    props :{
        id :{
            type: String,
            required:true
        }
    },
    data() {
        return {
            showEmptyMessage: false,
            questionaire:'',
            isSurveyDeleted:false,
            surveyDeletedMessage:'',
            survey:{questionaireId:'', questionaireName:'', survey:{}},
            message: "Click on Start Survey to Start your Survey",
            overlay:false,
            loading:false,
            questionIdsList:[],
            notification:{
                show:false,
                message:'',
                type:'',
                timeout:3000,
            },
            successNotification:{show:false, message:'', type:'', timeout:7000,},
            dialog: false,
            imagePath: '',
            backgroundSyncFailed: false,
        };
    },
    components: {
        // SurveyNotice,
        PrivacyPolicy,
        QuestionTemplate
    },
    created(){

        this.$logger.debug("Screen: Survey page.");
        this.$service.getLocation((v) => {this.userInfo.location = v});
        if(!this.userInfo.governmentId){
            this.$logger.debug("GovernmentId not found. Redirecting to home page.");
            this.$service.redirectToHomePage();
        }
    },
    computed :{

        ...mapGetters([
            "userInfo",
            "_questionaire"
        ]),
        response(){
            return this.$store.state.survey;
        },
        dependentQuestion(){
            return this.$store.state.dependentQuestions
        }
    },
    mounted(){
        if(!this.userInfo.governmentId){
            return
        }
        this.getQuestions()
    },
    methods: {
        ...mapMutations({resetSurvey: "resetSurvey", insertToQuestionaire:"insertToQuestionaire", showHideStreet:"showHideStreet"}),
        getQuestions: function(){
            if(navigator.onLine || process.env.NODE_ENV === "development"){
                this.getQuestionsWhenOnline();
            }else {
                this.getQuestionsWhenOffline();
            }
        },
        getQuestionsWhenOnline() {

            let counter = 0;
            this.callAPiToGetQuestions(counter);
            if(counter > 5){
                // window.location.reload();
            }
        },
        callAPiToGetQuestions(counter){

            let self = this;
            this.putLoader();
            let surveyNumber = this.$route.params.id;
            axios.get(`${config.baseUrl()}/getQuestions?surveyNumber=`+surveyNumber).then(function (responseData) {
                let response = responseData.data;
                let questionaire = response.questionaire;
                if (response.success && response.questionaire) {
                    self.questionaire = questionaire.questionaire;
                    self.$logger.debug("App is online. Getting Questionnaire of questionnaire name: "+questionaire.questionaireName+" id: "+questionaire.questionaireId);
                    const localStoreKeyForQuesitonaire = config.surveyResponse.questionaireKey;
                    self.saveToLocalStorage(localStoreKeyForQuesitonaire, questionaire);
                    self.processQuestionaire(self, questionaire);
                } else {
                    if(response.isProjectDeleted){
                        self.isSurveyDeleted = response.isProjectDeleted
                        self.surveyDeletedMessage = response.isProjectDeleted?response.msg:''
                        return
                    }
                    self.questionaire = '';
                    self.showEmptyMessage = true;
                    if(counter === 5){
                        self.$logger.debug("Could not fetch data in 5 retries. Suggesting User to reload the page.");
                        self.alert(self.$t("FailedToFetchDataFromServerMessage"), "info");
                    }
                    if(counter < 5){
                        self.$logger.debug("No Questions Found. Retrying .."+counter);
                        counter += 1;
                        self.callAPiToGetQuestions(counter);
                    }
                }
            }).catch(function (error) {

                self.$logger.debug(error.message);
                // self.showEmptyMessage = true;
                // self.alert(self.$t("backend_not_responding_failure_when_loading_survey"), "error");
                self.getQuestionsWhenOffline();
                // window.location.reload();
                //self.overlay = false;
            }).finally(function () {
                self.removeLoader();
            });
        },
        processQuestionaire: function(self, questionaire){
            self.questionaire = questionaire.questionaire;
            self.survey['questionaireId'] = questionaire.questionaireId;
            self.survey['questionaireName'] = questionaire.questionaireName;
            self.initDependency(questionaire.questionaire); //Initialize dependencies
        },
        async getQuestionsWhenOffline() {
            try{
                this.putLoader(); //displays loader
                const localStoreKeyForQuesitonaire = config.surveyResponse.questionaireKey;
                const questionaire = await this.getFromLocalStorage(localStoreKeyForQuesitonaire);
                this.$logger.debug("App is offline. Getting Questionnaire "+questionaire.questionaire.questionaireName+" from local db.");
                this.initQuestionaire(questionaire);
                this.removeLoader();
            } catch(err){
                this.$logger.error(err.message);
                this.showEmptyMessage = true;
                this.alert(this.$t("backend_not_responding_failure_when_loading_survey"), "error");
                this.removeLoader();
                setTimeout(function () {
                    location.reload();
                },1000);
            }
        },
        initQuestionaire: function(params){
            if(params !== undefined && params !== null){
                this.$logger.debug("Quesitonaire found in local db. Initializing ..");
                this.processQuestionaire(this, params);
            } else {
                this.empty_dataframe_message = this.$t("empty_dataframe_message");
                throw "Questionaire not available in cache"
            }
        },
        initDependency(questions){
            for (let i in questions) {
                const q = questions[i];
                const qId = q.questionId;
                if (!q && !qId) {
                    return;
                }
                let showVar = "show_" + qId;
                if(!this.dependentQuestion.hasOwnProperty(showVar)){
                    this.dependentQuestion[showVar] = true;
                }
                this.questionIdsList.push((qId).toString());
                this.storeImportantQuestions(q);
                if (q.answerType && (q.answerType == 'MultipleChoice' || q.answerType == 'RadioList' || q.answerType == 'DropdownCustom' || q.answerType == 'YesNoType' || q.answerType == 'NoYesType')) {
                    const choices = q.choices;
                    if (choices) {
                        for (let j in choices) {
                            const c = choices[j];
                            let dependentQuestion = c.dependentQuestions;
                            if (c && dependentQuestion) {
                                for (let dpQ of dependentQuestion) {
                                    this.checkAndFlagDependentQuestions(dpQ)
                                }
                            }
                        }
                    }
                }
                if("CityStreet" === q.answerType){
                    this.showHideStreet({key:'vuePreviewSurveyDataframe_street_'+qId, value: false});
                }
            }

            this.insertToQuestionaire({key:'questionIdsList', value:this.questionIdsList});
        },

        checkAndFlagDependentQuestions(qId){
            let showVar = "show_" + qId;
            if (config.dependency.showByDefault) {
                this.dependentQuestion[showVar] = true;
            } else {
                this.dependentQuestion[showVar] = false;
            }
        },
        submit () {
            this.$logger.debug("survey submit button clicked");
            // if(!this.validateFormInputs()){
            //     this.$logger.debug("Form Inputs validation failed");
            //     return;
            // }
            // this.$logger.debug("Surveyor information: "+ this.userInfo?JSON.stringify(this.userInfo):'');
            let isValidate = this.validateMandatoryQuestionsOnSubmit();
            if(isValidate){
                this.submitAsync();
            }else{
                this.alert(this.$t("snackbar_error_message_for_not_submitting_mandatory_question"), "error", 2500);

            }
        },


        validateMandatoryQuestionsOnSubmit(){
            let questionList = this.questionaire
            let counter = 0;
            for(let i=0; i<questionList.length; i++){
                if(questionList[i].importanceLevel === "Mandatory" && questionList[i].showMandatoryMessage && this.dependentQuestion['show_'+questionList[i].questionId]){
                    questionList[i].showMandatoryMessage = true;
                }else{
                    counter++;
                }
            }
            if(counter === questionList.length){
                return true;
            }
            else {
                return false;
            }

        },
        resetMandatoryQuestion(){
            let questionList = this.questionaire
            for(let i=0; i<questionList.length; i++){
                if(questionList[i].importanceLevel === "Mandatory" &&  this.dependentQuestion['show_'+questionList[i].questionId]){
                    questionList[i].showMandatoryMessage = true;
                }
            }

        },


        copyObject: function(from){
            return Object.assign({}, from);
        },

        validateFormInputs(){
            return this.$refs.vuePreviewSurveyDataframe_form.validate();
        },

        async submitAsync(){
            try{
                this.putLoader();
                this.disableSubmitButton();
                let response = await this.prepareResponse();
                const value = await this.saveLocally(response);
                await this.uploadToServer(value, response);
                /*if(navigator.onLine){
                    this.alert(this.$t("survey_save_success"), "success");
                    this.$logger.syncLog();
                }else {
                    this.alert(this.$t("survey_save_background"), "info");
                }*/
            }catch(err){
                this.$logger.error(err.message); // todo what to do if error occurs??
            } finally {
                this.enableSubmitButton();
                this.doAfterSave();
            }

        },

        async prepareResponse(){

            let allParams = {};
            const formattedData =  this.$service.formatData(this.response, this.questionIdsList);
            allParams['jsonResponse'] = formattedData;
            allParams["questionaireId"] = this.survey["questionaireId"];
            allParams["questionaireName"] = this.survey["questionaireName"];
            // allParams["vueDataModel"] = this.survey; //Oonly send if vueDataModel is needed
            allParams["identifier"] = this.createIdentifierHash();
            allParams["loginInfo"] = this.userInfo;
            allParams["loginInfo"]["submittedDate"] = new Date();
            try{
                allParams["deviceInfo"] = await SystemUtils.getDeviceInfo();
            }catch(e){
                this.$logger.error("Error to calculate logger information: " + e);
            }
            return Promise.resolve(allParams);
        },
        createIdentifierHash(){
            return ((+new Date) + Math.random()* 100).toString(32); // creating unique identifier from timestamp
        },
        async saveLocally(params){
            const localForageKey = config.surveyResponse.survaySaveKey;
            const oldDataFromLocalStorage = await this.getFromLocalStorage(localForageKey);
            const value = await this.prepareDataForLocalStorage(oldDataFromLocalStorage, params);
            await this.addNewDataToLocalForage(localForageKey, value.options);
            return await this.getFromLocalStorage(localForageKey);
        },
        async uploadToServer(params, surveyResponse){
            // return await this.uploadNow(params);
            if (!navigator.onLine && process.env.NODE_ENV !== "development") {
                const syncResp = await this.fireBackgroundSyncEvent();
                if (this.backgroundSyncFailed){
                    let webResponses = [];
                    webResponses.push(surveyResponse.identifier)
                    this.removeItemFromLocalDatabase(params.options.body, webResponses);
                }
                return syncResp
            } else {
                const res =  await this.uploadNow(params);
                this.alert(this.$t("survey_save_success"), "success");
                this.$logger.syncLog();
                return res
            }
        },
        doAfterSave(){
            this.removeLoader();
            if (this.backgroundSyncFailed){
                this.backgroundSyncFailed = false
                return
            }
            this._resetSurvey();
            if(!Vuex.Store.surveyFromLoginProcess && Vuex.Store.surveyFromDirectUrl){
                this.$router.push('/survey-saved')
            }

        },
        getFromLocalStorage(key){
            return offlineStorage.getItem(key);
        },
        prepareDataForLocalStorage(oldResponse, params){

            let responseList = this.getOldData(oldResponse);
            this.$logger.debug("Adding new values");
            responseList.push(params);
            this.$logger.debug(" Response Values:  "+ JSON.stringify( responseList));
            let options = {
                method: 'POST',
                //	headers: {
                //		'Content-Type': 'application/json'
                //	'Content-Type':'application/x-www-form-urlencoded'

                //	},
                body: JSON.stringify(responseList)
            };
            return Promise.resolve({options:options})
        },
        async addNewDataToLocalForage(localForageKey, options){
            const endpoint = config.surveyResponse.apiEndpoint;
            const value = { // this name van be used to get survey response values from the localforage store
                endpoint: endpoint,
                options: options
            };
            await this.saveToLocalStorage(localForageKey, value);
        },

        saveToLocalStorage(key, value){
            return offlineStorage.setItem(key, value);
        },
        getOldData(params){
            let oldData = [];
            if(params){
                this.$logger.debug("Old Values found from local storage.");
                oldData  = JSON.parse(params.options.body);
            }
            return oldData;
        },
        async uploadNow(params){
            const endpoint = params.endpoint;
            const response = params.options.body;
            const res = await this.callApi(endpoint, response);
            const webResponses = res.data.responsesSuccessfullySaved;// list of identifiers of successfull saves
            this.removeItemFromLocalDatabase(response, webResponses);
            return res
        },
        fireBackgroundSyncEvent(){

            const syncEventName = 'offlineSurveyStore';
            // Register the sync event on the service worker
            const _self = this;
            if ('serviceWorker' in navigator && 'SyncManager' in window) {
                return navigator.serviceWorker.ready.then(function (registerSW) {
                    _self.$logger.debug("Firing background sync event with name: " + syncEventName);
                    registerSW.sync.register(syncEventName);
                    _self.alert(_self.$t("survey_save_background"), "info");
                }).catch(function() {
                    _self.$logger.debug("system was unable to register for a sync, this could be an OS-level restriction");
                    _self.syncFailedPromise();
                });
            } else {
                _self.$logger.debug("serviceworker/sync not supported");
                return _self.syncFailedPromise();
            }
        },
        async syncFailedPromise() {
            this.backgroundSyncFailed = true
            this.alert(this.$t("Background_sync_failed"), "info", 3000);
            return Promise.resolve("No network access");
        },
        callApi(endpoint, params){
            this.$logger.debug("Connecting to endpoint "+endpoint);
            return axios({
                method:'post',
                url:endpoint,
                headers : {
                    'Content-Type': 'application/json'
                },
                data: params
            })
        },
        async removeItemFromLocalDatabase(itemFromLocalForage, webResponses) {

            const surveyResponses = JSON.parse(itemFromLocalForage);
            let resBuffer = [];
            for(const val in surveyResponses){
                const res = surveyResponses[val];
                if(!webResponses.includes(res.identifier)){
                    resBuffer.push(res);
                }
            }
            const localForageKey = config.surveyResponse.survaySaveKey;
            let options = {
                method: 'POST',
                body: JSON.stringify(resBuffer)
            };
            this.addNewDataToLocalForage(localForageKey, options);
        },
        _resetSurvey(){
            this.clear();
        },
        putLoader(){
            this.overlay = true;
        },
        removeLoader(){
            this.overlay = false;
        },
        disableSubmitButton(){
            this.loading = true;
        },
        enableSubmitButton(){
            this.loading = false;
        },
        clear () {
            // this.resetSurvey();
            // this.$refs.vuePreviewSurveyDataframe_form.reset();
            let formData = this.$refs.vuePreviewSurveyDataframe_form;
            for(let input of formData.inputs){
                if (input.internalValue)
                    input.internalValue='';
            }
            this.resetSurvey();
            this.resetImpQuestionMessage();
            this.resetMandatoryQuestion();
        },

        getBaseUrl () {
            this.$service.getBaseUrl();
        },
        alert(message, type, timeout = 0) {
            if(type === "success"){
                this.notification.show = false;
                this.successNotification.show = true;
                this.successNotification.type = type;
                this.successNotification.message = message;
                this.successNotification.timeout = timeout?timeout:7000;
            }else{
                this.successNotification.show = false;
                this.notification.show = true;
                this.notification.type = type?type:"info";
                this.notification.message = message;
                if(timeout > 0){
                    this.notification.timeout = timeout;
                }

            }

        },
        storeImportantQuestions(question){
            let modelString = question.questionId;
            if(question.isImportant){
                if (question.answerType === 'MultipleChoice'){
                    this._questionaire.importantQuestions['multipleChoice'][modelString] = question.choices.length;
                }
                this._questionaire.importantQuestions[modelString] = true;
            }
            this._questionaire.originalImpQuestion = Object.assign({}, this._questionaire.importantQuestions);
        },
        resetImpQuestionMessage(){
            try {
                this._questionaire.importantQuestions = Object.assign({}, this._questionaire.originalImpQuestion);
                this._questionaire.showImportantQuestionMessage = false;
            }catch (e) {
                this.alert("Failed to reset important question message.", "error")
            }
        },
        openPrivacyDialogue(){
            this.dialog = true;
        },
        closePrivacyDialog(value){
            this.dialog = value;
        },
    },
};
</script>
